import { readSignedInMarker } from "./rootResolution";

// Infrastructure hosts cannot be tenant slugs (also rejected by tenant provisioning).
const RESERVED_SUBDOMAINS = new Set([
  "www", "api", "admin", "mail", "ftp", "localhost", "app", "web", "mobile",
  "test", "staging", "dev", "demo", "support", "help", "blog", "news",
]);

export function getSubdomain(hostname: string): string | null {
  if (hostname.includes("localhost")) {
    const parts = hostname.split(".");
    return parts.length > 1 && parts[0] !== "localhost" ? parts[0] : null;
  }
  const parts = hostname.toLowerCase().split(".");
  if (parts.length >= 3 && hostname.toLowerCase().endsWith(".zurilink.com")) {
    return RESERVED_SUBDOMAINS.has(parts[0]) ? null : parts[0];
  }
  return null;
}

export function startsOnPublicStory(): boolean {
  return !getSubdomain(window.location.hostname) &&
    window.location.pathname === "/" && !readSignedInMarker();
}
